import { assertArray, assertString } from "../utils/assertions";
import { nowIso } from "../utils/timestamps";

export const createLocalSession = ({
  id,
  userId,
  username,
  displayName,
  vesselId,
  role,
  roles = [],
  credentialPackageVersion,
  authenticatedAt = nowIso(),
  lastActivityAt = authenticatedAt,
  status = "active",
}) => {
  assertString(id, "localSession.id");
  assertString(userId, "localSession.userId");
  assertString(username, "localSession.username");
  assertString(displayName, "localSession.displayName");
  assertString(vesselId, "localSession.vesselId");
  assertString(role, "localSession.role");
  assertArray(roles, "localSession.roles");
  assertString(status, "localSession.status");

  return {
    id,
    userId,
    username,
    displayName,
    vesselId,
    role,
    roles,
    credentialPackageVersion,
    authenticatedAt,
    lastActivityAt,
    status,
  };
};

